export default __webpack_public_path__ + "content/media/Black-IcoTwitter.ae31f3b7.svg";